export const mapboxAccessToken = 'pk.eyJ1Ijoic2lzbXMiLCJhIjoiY2pzNGNnZzg4MDE3bjQzcWs0NXY0YmV3MCJ9.2pf_XKV1uON2_9iaS8l-oA';
